import { useState, useRef } from "react";

export const useBubbleChart = (title) => {
    const chartRef = useRef(null);

    const [options, setOptions] = useState({
        chart: {
            type: "bubble",
            plotBorderWidth: 1,
            zoomType: "xy",
            events: {
                load: function () {
                    chartRef.current = this;
                },
            },
        },
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando...",
            noData: "No hay datos para mostrar",
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        tooltip: {
            formatter: function () {
                const xCategory = this.series.xAxis.categories?.[this.point.x] ?? this.point.x;
                const yCategory = this.series.yAxis.categories?.[this.point.y] ?? this.point.y;
                const count = this.point.value ?? this.point.z ?? this.point[2];
                return `
                    <b>Categoría:</b> ${xCategory}<br/>
                    <b>Subcategoría:</b> ${yCategory}<br/>
                    <b>Cantidad:</b> ${count}
                `;
            },
            useHTML: true,
        },
        legend: {
            enabled: false,
        },
        title: {
            text: title,
            align: "left",
        },
        xAxis: {
            labels: {
                formatter: function () {
                    return typeof this.value !== "number" ? this.value : "";
                },
            },
        },
        yAxis: {
            title: {
                text: null,
            },
            startOnTick: false,
            endOnTick: false,
            minPadding: 0,
            maxPadding: 0,
            tickPixelInterval: 1,
            labels: {
                formatter: function () {
                    return typeof this.value !== "number" ? this.value : "";
                },
            },
        },
        series: [],
        credits: { enabled: false },
    });

    const showLoading = () => chartRef.current?.showLoading();
    const hideLoading = () => chartRef.current?.hideLoading();

    const onChartReady = (chartInstance) => {
        chartRef.current = chartInstance;
    };

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
        onChartReady,
    };
};
